module.exports = __webpack_public_path__ + "img/x-logo-black.c019bd43.png";